import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";

const menuList = [
  { label: "Dashboard", icon: "dashboard-2-line", path: "/dashboard" },
  {
    label: "Learners",
    icon: "group-line",
    subNav: [
      [
        {
          subNavMenu: [
            { label: "All Learners", path: "/learners/all-learners" },
            { label: "Active Learners", path: "/learners/active-learners" },
            { label: "Completed Learners", path: "/learners/completed-learners" },
            { label: "Dropouts / Inactive", path: "/learners/dropouts-inactive" },
          ],
        },
      ],
    ],
  },
  {
    label: "Support Tickets",
    icon: "coupon-2-line",
    subNav: [
      [
        {
          subNavMenu: [
            { label: "All Tickets", path: "/support-tickets/all-tickets" },
            { label: "Active Tickets", path: "/support-tickets/active-tickets" },
            { label: "In process", path: "/support-tickets/in-process-tickets" },
            { label: "Completed Tickets", path: "/support-tickets/completed-tickets" },
          ],
        },
      ],
    ],
  },
  {
    label: "Reports",
    icon: "folder-chart-line",
    subNav: [
      [
        {
          subNavMenu: [
            { label: "Student Performance", path: "/reports/student-performance" },
            { label: "Course Completion Rates", path: "/reports/course-completion-rates" },
            { label: "LMS-wise Reports", path: "/reports/lms-wise-reports" },
          ],
        },
      ],
    ],
  },
  // { label: "Enrollments", icon: "contacts-book-upload-line", path: "/enrollments" },
  // { label: "Certifications", icon: "verified-badge-line", path: "/certifications" },
  // { label: "Integrations", icon: "webhook-fill", path: "/integrations" },
  // { label: "Reports", icon: "folder-chart-line", path: "/reports" },
  {
    label: "Communication",
    icon: "mail-line",
    subNav: [
      [
        {
          subNavMenu: [
            { label: "Email Notifications", path: "/communication/email-notifications" },
            { label: "SMS / WhatsApp (Optional)", path: "/communication/sms-whatsapp" },
            { label: "Student Announcements", path: "/communication/student-announcements" },
          ],
        },
      ],
    ],
  },
  {
    label: "Users & Roles",
    icon: "group-line",
    subNav: [
      [
        {
          subNavMenu: [
            { label: "Admin", path: "/users-roles/admin" },
            { label: "Academic Staff", path: "/users-roles/academic-staff" },
            { label: "Support Staff", path: "/users-roles/support-staff" },
          ],
        },
      ],
    ],
  },
  {
    label: "Settings",
    icon: "settings-3-line",
    subNav: [
      [
        {
          subNavMenu: [
            { label: "CRM Settings", path: "/settings/crm-settings" },
            { label: "Field Customization", path: "/settings/field-customization" },
            { label: "Permissions", path: "/settings/permissions" },
          ],
        },
      ],
    ],
  },
];

const MenuColumn = ({ subNavCol }) => {
  return (
    <div className="submenu-list">
      {subNavCol.label && <strong>{subNavCol.label}</strong>}
      <ul>
        {subNavCol.subNavMenu.map((subItem, idx) => (
          <li key={idx}>
            <NavLink to={subItem.path}>
              <i className={`ri-${subItem.icon}`}></i>
              {subItem.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Sidebar = ({ onLogout }) => {
  const location = useLocation();
  const onToogleMenu = () => {
    const element = document.getElementById("toogleBoby");
    element.classList.toggle("sidebar-enable");
    element.setAttribute("data-menu-size", element.classList.contains("sidebar-enable") ? "condensed" : "default");
  };
  const isSubMenuActive = (subNav, pathname) => {
    return subNav.some((col) => col.some((section) => section.subNavMenu.some((item) => pathname.startsWith(item.path))));
  };

  return (
    <div className="main-nav">
      <div className="main-nav-inner">
        <button type="button" className="button-toggle-menu topbar-button" onClick={onToogleMenu}>
          <i className="ri-menu-2-line fs-24"></i>
        </button>
        <ul className="navbar-nav" id="navbar-nav">
          {menuList.map((item, idx) => (
            <li key={idx} className="nav-item fadeUp" style={{ animationDelay: `${0.1 * (idx + 1)}s` }}>
              {item.path ? (
                <NavLink
                  to={item.path}
                  end={item.path === "/"} // exact for root
                  className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                >
                  <span className="nav-icon">
                    <i className={`ri-${item.icon}`}></i>
                  </span>
                  <span className="nav-text">{item.label}</span>
                </NavLink>
              ) : (
                <a className={`menu-list ${item.subNav && isSubMenuActive(item.subNav, location.pathname) ? "active" : ""}`}>
                  <i className={`ri-${item.icon}`}></i>
                  <label>{item.label}</label>
                </a>
              )}
              {item.subNav && (
                <div className="subnav">
                  <label>{item.label}</label>
                  {item.subNav.map((subNavCol, idx) => (
                    <div key={idx} className="column">
                      {subNavCol.map((subNavitem, idx) => (
                        <MenuColumn key={idx} subNavCol={subNavitem} />
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </li>
          ))}

          <li className="nav-item fadeUp" style={{ animationDelay: `${0.1 * (menuList.length + 1)}s` }}>
            <button className="nav-link" type="button" onClick={onLogout}>
              <span className="nav-icon">
                <i className="ri-logout-box-line"></i>
              </span>
              <span className="nav-text">Logout</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
